import Iframe from "react-iframe";

type Props = {
  language: string;
};

export const IFrameList = ({ language }: Props) => {
  return (
    <div className="flex w-full h-full py-safe-offset-12 px-safe">
      {language === "swedish" ? (
        <Iframe
          allow="geolocation"
          url="https://iot.lunet.se/dashboard/79741f60-91a8-11ed-999c-c738a46680bf?publicId=59878940-6788-11eb-afaf-e3eb52d62c89"
          className="w-full h-full"
        />
      ) : (
        <Iframe
          allow="geolocation"
          url="https://iot.lunet.se/dashboard/81ef2380-933b-11ed-999c-c738a46680bf?publicId=59878940-6788-11eb-afaf-e3eb52d62c89"
          className="w-full h-full"
        />
      )}
    </div>
  );
};
